import { render, staticRenderFns } from "./video_bill.vue?vue&type=template&id=6a0a5aed&scoped=true&"
import script from "./video_bill.vue?vue&type=script&lang=js&"
export * from "./video_bill.vue?vue&type=script&lang=js&"
import style0 from "./video_bill.vue?vue&type=style&index=0&id=6a0a5aed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a5aed",
  null
  
)

export default component.exports